import AppModuleType from "../../services/App/AppModuleType.js";

export default {
  Tabs: {
    Details: AppModuleType.Details.Name
  }
}